import { tagging } from "@/mapping/tagging"

const NOSTO_COLLECTION_ROOT = '[data-section-type="nosto-collection"]'

/**
 * Resolves Shopify collection id for Nosto category queries.
 * Prefer Nosto page tagging when present; fall back to theme `data-shopify-collection-id`
 * (some storefronts strip numeric-only text inside hidden `.nosto_category_id` tags).
 */
export function resolveCategoryIdForQuery(): string | undefined {
  const fromTagging = tagging.categoryId()
  const root = document.querySelector(NOSTO_COLLECTION_ROOT)
  const fromData = root?.getAttribute("data-shopify-collection-id")?.trim()
  const fromLegacyDiv = document.querySelector(".nosto_category_id")?.textContent?.trim()
  const resolved =
    fromTagging != null && String(fromTagging).trim() !== ""
      ? String(fromTagging).trim()
      : fromData || fromLegacyDiv || undefined

  if (fromTagging != null && String(fromTagging).trim() !== "") {
    return String(fromTagging).trim()
  }

  if (fromData) {
    return fromData
  }

  return resolved
}

export function resolveCategoryPathForQuery(): string | undefined {
  const fromTagging = tagging.categoryPath()
  const fromLegacyDiv = document.querySelector(".nosto_category")?.textContent?.trim()
  const resolved =
    fromTagging != null && String(fromTagging).trim() !== "" ? String(fromTagging).trim() : fromLegacyDiv || undefined

  if (fromTagging != null && String(fromTagging).trim() !== "") {
    return String(fromTagging).trim()
  }

  return resolved
}
